import {
  Link,
  Links,
  LiveReload,
  Meta,
  NavLink,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import React, { useState } from "react";
import DeImpersonateButton from "~/components/de-impersonate-button.tsx";

export default function SiteFooter(props: { requestURL?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className={`SiteFooter`}>
        <div className="SiteFooter__Copyright">
          <i className="fa-light fa-copyright"></i> {new Date().getFullYear()}{" "}
          TPM MEDIA LLC. ALL RIGHTS RESERVED
        </div>
        <div className="SiteFooter__Help">
          {open && (
            <div className="SiteFooter__HelpMore">
              <p>Question or problem?</p>
              <p>
                <Link to={`https://talkingpointsmemo.com/faq`}>Try our FAQ</Link> or{" "}
                <Link to={`https://talkingpointsmemo.com/contact`}>contact us</Link>
              </p>
            </div>
          )}
          <span
            onClick={() => {
              setOpen(!open);
            }}
          >
            <span
              style={open ? { opacity: 0, width: 0, position: "absolute", right: "-10000px" } : {}}
            >
              <i
                className={`fa-solid fa-circle-question fa-2x `}
              >
              </i>
            </span>
            <span
              style={open ? {} : { opacity: 0, width: 0, position: "absolute", right: "-10000px" }}
            >
              <i className={`fa-solid fa-circle-x fa-2x `}>
              </i>
            </span>
          </span>
        </div>
      </footer>
    </>
  );
}

/* not used, can probably delete? */
export function SiteFooter2(props: { requestURL?: string }) {
  const requestUrl = props.requestURL || "https://talkingpointsmemo.com/";
  return (
    <footer id="footer" className="js_site-footer SiteFooter">
      <div className="container">
        <div className="SiteFooter__Follow">
          <div className="SiteFooter__FollowText">Follow TPM</div>
          <div className="SiteFooter__Social">
            <a
              href="https://twitter.com/tpm"
              title="twitter"
              className="footer-social-twitter"
            >
              <i className="fab fa-twitter" aria-hidden="true"></i>
            </a>
            <a
              href="https://facebook.com/talkingpointsmemo"
              title="facebook"
              className="footer-social-facebook"
            >
              <i className="fab fa-facebook-f" aria-hidden="true"></i>
            </a>
            <a
              href="https://www.instagram.com/talkingpointsmemo/"
              title="instagram"
              className="footer-social-instagram"
            >
              <i className="fab fa-instagram" aria-hidden="true"></i>
            </a>
          </div>
        </div>
        <nav className="SiteFooter__Nav">
          <ul>
            <li>
              <Link to={`${requestUrl}about`}>About</Link>
            </li>
            <li>
              <Link
                to={`${requestUrl}membershipsutm_source=on_site&utm_medium=footer_button&utm_campaign=on_site_membership_links`}
              >
                Memberships
              </Link>
            </li>
            <li>
              <Link to={`${requestUrl}careers`}>Careers</Link>
            </li>
            <li>
              <a
                href="https://s3.amazonaws.com/tpm-media/2021-ad-offerings-site_compressed.pdf"
                target="_blank"
              >
                Advertise
              </a>
            </li>
            <li>
              <a href="http://status.talkingpointsmemo.com" target="_blank">
                Site Status
              </a>
            </li>
            <li>
              <a href="/privacy">Privacy Policy</a>
            </li>
            <li>
              <Link to={`${requestUrl}faq`}>FAQ</Link>
            </li>
            <li>
              <Link to={`${requestUrl}newsletters`}>Newsletters</Link>
            </li>
            <li>
              <Link to={`${requestUrl}pitch-us`}>Pitch Us</Link>
            </li>
            <li>
              <Link to={`${requestUrl}contact`}>Contact</Link>
            </li>
            <li>
              <Link to={`${requestUrl}terms-of-use`}>Terms of Use</Link>
            </li>
            <li>
              <Link to={`${requestUrl}ccpa-notice`}>CCPA Notice</Link>
            </li>
          </ul>
        </nav>
        <div className="SiteFooter__Bottom">
          <img
            className="SiteFooter__Logo"
            src="https://talkingpointsmemo.com/wp-content/themes/talkingpointsmemo/assets/images/logo/TPMRedes_FullLogo_GrayLight.svg"
            alt="Talking Point Memo"
          />
          <div className="SiteFooter__Copyright">
            <i className="fal fa-copyright"></i> {new Date().getFullYear()}{" "}
            TPM MEDIA LLC. ALL RIGHTS RESERVED
          </div>
        </div>
      </div>
    </footer>
  );
}
